
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { GoodsCategoryListDto } from '@/api/commodity'
import { Tree } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

@Component({
  name: 'categoryTree',
  components: {Tree}
})
export default class CategoryTree extends Vue {
  @Prop({default: ''}) treeId: string
  @Prop({default: []}) treeData: GoodsCategoryListDto[]
  @Prop({default: false}) showTemp!: boolean
  selectedKeys = ['']

  fieldNames = {
    children: 'children',
    title: 'categoryName',
    key: 'hierarchyId'
  }

  @Watch('treeId', {immediate: true})
  treeIdChange () {
    this.selectedKeys = [this.treeId]
  }

  cancel () {
    this.$emit('cancel')
  }

  handleSelect (value, e: { selected: any, selectedNodes, node, event }) {
    this.selectedKeys = value
    this.$emit('load', {text:e.selectedNodes[0].data.props.title, value:value[0]})
  }
}
